/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * astral/v1/api.proto
 * OpenAPI spec version: version not set
 */
import { useInfiniteQuery, useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import * as axios from 'axios';
import type { AxiosError, AxiosRequestConfig, AxiosResponse } from 'axios';

import type {
  CountExceptionsByAssigneeParams,
  CountExceptionsByAutomationParams,
  CountExceptionsByGroupParams,
  CreateExceptionParams,
  CreateGuideEntryParams,
  DeleteGuideEntryParams,
  ExceptionManagerServiceArchiveExceptionsBody,
  ExceptionManagerServiceAssignExceptionsBody,
  ExceptionManagerServiceQueryExceptionInsightsBody,
  ExceptionManagerServiceRetryExceptionsBody,
  ExceptionManagerServiceSetExceptionGroupRoutingBody,
  ExceptionManagerServiceSkipExceptionsBody,
  ExceptionManagerServiceUnarchiveExceptionsBody,
  ListEventsParams,
  ListExceptionClustersParams,
  ListExceptionGroupsParams,
  ListExceptionsParams,
  ListGuideApplicationsParams,
  ListGuideEntriesParams,
  ListGuideEntryVersionsParams,
  RpcStatus,
  TroubleshootingGuideServiceQueryGuideStatsBody,
  TroubleshootingGuideServiceRevertGuideEntryBody,
  TroubleshootingGuideServiceTransitionGuideEntryStateBody,
  UpdateGuideEntryBody,
  UpdateGuideEntryParams,
  V1ArchiveExceptionsResponse,
  V1AssignExceptionsResponse,
  V1CancelGenerationResponse,
  V1ClassifyExceptionRequest,
  V1CountExceptionsByAssigneeResponse,
  V1CountExceptionsByAutomationResponse,
  V1CountExceptionsByGroupResponse,
  V1CreateRunAssistantResponse,
  V1Event,
  V1Exception,
  V1GetHermesExceptionContextResponse,
  V1GuideEntry,
  V1ListEventsResponse,
  V1ListExceptionClustersResponse,
  V1ListExceptionGroupsResponse,
  V1ListExceptionResolutionsRequest,
  V1ListExceptionResolutionsResponse,
  V1ListExceptionsResponse,
  V1ListGuideApplicationsResponse,
  V1ListGuideEntriesResponse,
  V1ListGuideEntryVersionsResponse,
  V1MarkExceptionResolvedRequest,
  V1PatchStepRequest,
  V1PatchStepResponse,
  V1QueryExceptionInsightsResponse,
  V1QueryGuideStatsResponse,
  V1ReadExceptionValueRequest,
  V1ReadExceptionValueResponse,
  V1RetryExceptionsResponse,
  V1RetryStepRequest,
  V1RetryStepResponse,
  V1SearchResolutionsRequest,
  V1SearchResolutionsResponse,
  V1SetExceptionGroupRoutingResponse,
  V1SkipExceptionsResponse,
  V1SkipStepRequest,
  V1SkipStepResponse,
  V1StoreExceptionReportRequest,
  V1StoreExceptionReportResponse,
  V1StoreExceptionResolutionRequest,
  V1StoreExceptionResolutionResponse,
  V1UnarchiveExceptionsResponse,
} from '../models';

// https://stackoverflow.com/questions/49579094/typescript-conditional-types-filter-out-readonly-properties-pick-only-requir/49579497#49579497
type IfEquals<X, Y, A = X, B = never> =
  (<T>() => T extends X ? 1 : 2) extends <T>() => T extends Y ? 1 : 2 ? A : B;

type WritableKeys<T> = {
  [P in keyof T]-?: IfEquals<
    { [Q in P]: T[P] },
    { -readonly [Q in P]: T[P] },
    P
  >;
}[keyof T];

type UnionToIntersection<U> = (U extends any ? (k: U) => void : never) extends (
  k: infer I,
) => void
  ? I
  : never;
type DistributeReadOnlyOverUnions<T> = T extends any ? NonReadonly<T> : never;

type Writable<T> = Pick<T, WritableKeys<T>>;
type NonReadonly<T> = [T] extends [UnionToIntersection<T>]
  ? {
      [P in keyof Writable<T>]: T[P] extends object
        ? NonReadonly<NonNullable<T[P]>>
        : T[P];
    }
  : DistributeReadOnlyOverUnions<T>;

/**
 * @summary Lists TSG entries for an automation. Sorted by DESC order of create time.
By default, soft-deleted entries are filtered out. Use show_deleted=true to include them.
 */
export const listGuideEntries = (
  organization: string,
  workspace: string,
  automation: string,
  params?: ListGuideEntriesParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1ListGuideEntriesResponse>> => {
  return axios.default.get(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/guideEntries`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getListGuideEntriesQueryKey = (
  organization?: string,
  workspace?: string,
  automation?: string,
  params?: ListGuideEntriesParams,
) => {
  return [
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/guideEntries`,
    ...(params ? [params] : []),
  ] as const;
};

export const getListGuideEntriesQueryOptions = <
  TData = Awaited<ReturnType<typeof listGuideEntries>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  params?: ListGuideEntriesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listGuideEntries>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListGuideEntriesQueryKey(organization, workspace, automation, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listGuideEntries>>
  > = ({ signal }) =>
    listGuideEntries(organization, workspace, automation, params, {
      signal,
      ...axiosOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled: !!(organization && workspace && automation),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listGuideEntries>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListGuideEntriesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listGuideEntries>>
>;
export type ListGuideEntriesQueryError = AxiosError<RpcStatus>;

export function useListGuideEntries<
  TData = Awaited<ReturnType<typeof listGuideEntries>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  params: undefined | ListGuideEntriesParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listGuideEntries>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listGuideEntries>>,
          TError,
          Awaited<ReturnType<typeof listGuideEntries>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListGuideEntries<
  TData = Awaited<ReturnType<typeof listGuideEntries>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  params?: ListGuideEntriesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listGuideEntries>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listGuideEntries>>,
          TError,
          Awaited<ReturnType<typeof listGuideEntries>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListGuideEntries<
  TData = Awaited<ReturnType<typeof listGuideEntries>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  params?: ListGuideEntriesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listGuideEntries>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Lists TSG entries for an automation. Sorted by DESC order of create time.
By default, soft-deleted entries are filtered out. Use show_deleted=true to include them.
 */

export function useListGuideEntries<
  TData = Awaited<ReturnType<typeof listGuideEntries>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  params?: ListGuideEntriesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listGuideEntries>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getListGuideEntriesQueryOptions(
    organization,
    workspace,
    automation,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Creates a TSG entry for an automation. Created by the exception resolver
agent during resolution, or directly by users/clients over HTTP to author
a learning (kind="learning") that is not tied to a specific exception.
 */
export const createGuideEntry = (
  organization: string,
  workspace: string,
  automation: string,
  v1GuideEntry: NonReadonly<V1GuideEntry>,
  params?: CreateGuideEntryParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1GuideEntry>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/guideEntries`,
    v1GuideEntry,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getCreateGuideEntryMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createGuideEntry>>,
    TError,
    {
      organization: string;
      workspace: string;
      automation: string;
      data: NonReadonly<V1GuideEntry>;
      params?: CreateGuideEntryParams;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createGuideEntry>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    data: NonReadonly<V1GuideEntry>;
    params?: CreateGuideEntryParams;
  },
  TContext
> => {
  const mutationKey = ['createGuideEntry'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createGuideEntry>>,
    {
      organization: string;
      workspace: string;
      automation: string;
      data: NonReadonly<V1GuideEntry>;
      params?: CreateGuideEntryParams;
    }
  > = props => {
    const { organization, workspace, automation, data, params } = props ?? {};

    return createGuideEntry(
      organization,
      workspace,
      automation,
      data,
      params,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateGuideEntryMutationResult = NonNullable<
  Awaited<ReturnType<typeof createGuideEntry>>
>;
export type CreateGuideEntryMutationBody = NonReadonly<V1GuideEntry>;
export type CreateGuideEntryMutationError = AxiosError<RpcStatus>;

/**
 * @summary Creates a TSG entry for an automation. Created by the exception resolver
agent during resolution, or directly by users/clients over HTTP to author
a learning (kind="learning") that is not tied to a specific exception.
 */
export const useCreateGuideEntry = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createGuideEntry>>,
      TError,
      {
        organization: string;
        workspace: string;
        automation: string;
        data: NonReadonly<V1GuideEntry>;
        params?: CreateGuideEntryParams;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createGuideEntry>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    data: NonReadonly<V1GuideEntry>;
    params?: CreateGuideEntryParams;
  },
  TContext
> => {
  const mutationOptions = getCreateGuideEntryMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Gets a TSG entry by ID
 */
export const getGuideEntry = (
  organization: string,
  workspace: string,
  automation: string,
  guideEntrie: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1GuideEntry>> => {
  return axios.default.get(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/guideEntries/${guideEntrie}`,
    options,
  );
};

export const getGetGuideEntryQueryKey = (
  organization?: string,
  workspace?: string,
  automation?: string,
  guideEntrie?: string,
) => {
  return [
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/guideEntries/${guideEntrie}`,
  ] as const;
};

export const getGetGuideEntryQueryOptions = <
  TData = Awaited<ReturnType<typeof getGuideEntry>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  guideEntrie: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getGuideEntry>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetGuideEntryQueryKey(organization, workspace, automation, guideEntrie);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getGuideEntry>>> = ({
    signal,
  }) =>
    getGuideEntry(organization, workspace, automation, guideEntrie, {
      signal,
      ...axiosOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled: !!(organization && workspace && automation && guideEntrie),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getGuideEntry>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetGuideEntryQueryResult = NonNullable<
  Awaited<ReturnType<typeof getGuideEntry>>
>;
export type GetGuideEntryQueryError = AxiosError<RpcStatus>;

export function useGetGuideEntry<
  TData = Awaited<ReturnType<typeof getGuideEntry>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  guideEntrie: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getGuideEntry>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getGuideEntry>>,
          TError,
          Awaited<ReturnType<typeof getGuideEntry>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetGuideEntry<
  TData = Awaited<ReturnType<typeof getGuideEntry>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  guideEntrie: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getGuideEntry>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getGuideEntry>>,
          TError,
          Awaited<ReturnType<typeof getGuideEntry>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetGuideEntry<
  TData = Awaited<ReturnType<typeof getGuideEntry>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  guideEntrie: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getGuideEntry>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Gets a TSG entry by ID
 */

export function useGetGuideEntry<
  TData = Awaited<ReturnType<typeof getGuideEntry>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  guideEntrie: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getGuideEntry>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetGuideEntryQueryOptions(
    organization,
    workspace,
    automation,
    guideEntrie,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Soft-deletes a TSG entry.
The entry is marked as deleted but not physically removed.
Returns the guide entry with delete_time set.
 */
export const deleteGuideEntry = (
  organization: string,
  workspace: string,
  automation: string,
  guideEntrie: string,
  params?: DeleteGuideEntryParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1GuideEntry>> => {
  return axios.default.delete(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/guideEntries/${guideEntrie}`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getDeleteGuideEntryMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteGuideEntry>>,
    TError,
    {
      organization: string;
      workspace: string;
      automation: string;
      guideEntrie: string;
      params?: DeleteGuideEntryParams;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteGuideEntry>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    guideEntrie: string;
    params?: DeleteGuideEntryParams;
  },
  TContext
> => {
  const mutationKey = ['deleteGuideEntry'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteGuideEntry>>,
    {
      organization: string;
      workspace: string;
      automation: string;
      guideEntrie: string;
      params?: DeleteGuideEntryParams;
    }
  > = props => {
    const { organization, workspace, automation, guideEntrie, params } =
      props ?? {};

    return deleteGuideEntry(
      organization,
      workspace,
      automation,
      guideEntrie,
      params,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteGuideEntryMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteGuideEntry>>
>;

export type DeleteGuideEntryMutationError = AxiosError<RpcStatus>;

/**
 * @summary Soft-deletes a TSG entry.
The entry is marked as deleted but not physically removed.
Returns the guide entry with delete_time set.
 */
export const useDeleteGuideEntry = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteGuideEntry>>,
      TError,
      {
        organization: string;
        workspace: string;
        automation: string;
        guideEntrie: string;
        params?: DeleteGuideEntryParams;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteGuideEntry>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    guideEntrie: string;
    params?: DeleteGuideEntryParams;
  },
  TContext
> => {
  const mutationOptions = getDeleteGuideEntryMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Updates a TSG entry.
Only the content field can be updated.
 */
export const updateGuideEntry = (
  organization: string,
  workspace: string,
  automation: string,
  guideEntrie: string,
  updateGuideEntryBody: NonReadonly<UpdateGuideEntryBody>,
  params?: UpdateGuideEntryParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1GuideEntry>> => {
  return axios.default.patch(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/guideEntries/${guideEntrie}`,
    updateGuideEntryBody,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getUpdateGuideEntryMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateGuideEntry>>,
    TError,
    {
      organization: string;
      workspace: string;
      automation: string;
      guideEntrie: string;
      data: NonReadonly<UpdateGuideEntryBody>;
      params?: UpdateGuideEntryParams;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateGuideEntry>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    guideEntrie: string;
    data: NonReadonly<UpdateGuideEntryBody>;
    params?: UpdateGuideEntryParams;
  },
  TContext
> => {
  const mutationKey = ['updateGuideEntry'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateGuideEntry>>,
    {
      organization: string;
      workspace: string;
      automation: string;
      guideEntrie: string;
      data: NonReadonly<UpdateGuideEntryBody>;
      params?: UpdateGuideEntryParams;
    }
  > = props => {
    const { organization, workspace, automation, guideEntrie, data, params } =
      props ?? {};

    return updateGuideEntry(
      organization,
      workspace,
      automation,
      guideEntrie,
      data,
      params,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateGuideEntryMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateGuideEntry>>
>;
export type UpdateGuideEntryMutationBody = NonReadonly<UpdateGuideEntryBody>;
export type UpdateGuideEntryMutationError = AxiosError<RpcStatus>;

/**
 * @summary Updates a TSG entry.
Only the content field can be updated.
 */
export const useUpdateGuideEntry = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateGuideEntry>>,
      TError,
      {
        organization: string;
        workspace: string;
        automation: string;
        guideEntrie: string;
        data: NonReadonly<UpdateGuideEntryBody>;
        params?: UpdateGuideEntryParams;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateGuideEntry>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    guideEntrie: string;
    data: NonReadonly<UpdateGuideEntryBody>;
    params?: UpdateGuideEntryParams;
  },
  TContext
> => {
  const mutationOptions = getUpdateGuideEntryMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Lists applications of a guide entry.
Returns a list of applications showing when and where the guide was applied.
UI can use this to fetch run details from Jeeves for the Applied Runs table.
 */
export const listGuideApplications = (
  organization: string,
  workspace: string,
  automation: string,
  guideEntrie: string,
  params?: ListGuideApplicationsParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1ListGuideApplicationsResponse>> => {
  return axios.default.get(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/guideEntries/${guideEntrie}/applications`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getListGuideApplicationsQueryKey = (
  organization?: string,
  workspace?: string,
  automation?: string,
  guideEntrie?: string,
  params?: ListGuideApplicationsParams,
) => {
  return [
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/guideEntries/${guideEntrie}/applications`,
    ...(params ? [params] : []),
  ] as const;
};

export const getListGuideApplicationsQueryOptions = <
  TData = Awaited<ReturnType<typeof listGuideApplications>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  guideEntrie: string,
  params?: ListGuideApplicationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listGuideApplications>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListGuideApplicationsQueryKey(
      organization,
      workspace,
      automation,
      guideEntrie,
      params,
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listGuideApplications>>
  > = ({ signal }) =>
    listGuideApplications(
      organization,
      workspace,
      automation,
      guideEntrie,
      params,
      { signal, ...axiosOptions },
    );

  return {
    queryKey,
    queryFn,
    enabled: !!(organization && workspace && automation && guideEntrie),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listGuideApplications>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListGuideApplicationsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listGuideApplications>>
>;
export type ListGuideApplicationsQueryError = AxiosError<RpcStatus>;

export function useListGuideApplications<
  TData = Awaited<ReturnType<typeof listGuideApplications>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  guideEntrie: string,
  params: undefined | ListGuideApplicationsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listGuideApplications>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listGuideApplications>>,
          TError,
          Awaited<ReturnType<typeof listGuideApplications>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListGuideApplications<
  TData = Awaited<ReturnType<typeof listGuideApplications>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  guideEntrie: string,
  params?: ListGuideApplicationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listGuideApplications>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listGuideApplications>>,
          TError,
          Awaited<ReturnType<typeof listGuideApplications>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListGuideApplications<
  TData = Awaited<ReturnType<typeof listGuideApplications>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  guideEntrie: string,
  params?: ListGuideApplicationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listGuideApplications>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Lists applications of a guide entry.
Returns a list of applications showing when and where the guide was applied.
UI can use this to fetch run details from Jeeves for the Applied Runs table.
 */

export function useListGuideApplications<
  TData = Awaited<ReturnType<typeof listGuideApplications>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  guideEntrie: string,
  params?: ListGuideApplicationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listGuideApplications>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getListGuideApplicationsQueryOptions(
    organization,
    workspace,
    automation,
    guideEntrie,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Lists all versions of a guide entry, newest first (by DESC version order).
Unlike GetGuideEntry/ListGuideEntries (which return only the effective
version per entry), this returns the full version history for a single
guide entry so clients can inspect and revert to a previous version.
 */
export const listGuideEntryVersions = (
  organization: string,
  workspace: string,
  automation: string,
  guideEntrie: string,
  params?: ListGuideEntryVersionsParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1ListGuideEntryVersionsResponse>> => {
  return axios.default.get(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/guideEntries/${guideEntrie}:listVersions`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getListGuideEntryVersionsQueryKey = (
  organization?: string,
  workspace?: string,
  automation?: string,
  guideEntrie?: string,
  params?: ListGuideEntryVersionsParams,
) => {
  return [
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/guideEntries/${guideEntrie}:listVersions`,
    ...(params ? [params] : []),
  ] as const;
};

export const getListGuideEntryVersionsQueryOptions = <
  TData = Awaited<ReturnType<typeof listGuideEntryVersions>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  guideEntrie: string,
  params?: ListGuideEntryVersionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listGuideEntryVersions>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListGuideEntryVersionsQueryKey(
      organization,
      workspace,
      automation,
      guideEntrie,
      params,
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listGuideEntryVersions>>
  > = ({ signal }) =>
    listGuideEntryVersions(
      organization,
      workspace,
      automation,
      guideEntrie,
      params,
      { signal, ...axiosOptions },
    );

  return {
    queryKey,
    queryFn,
    enabled: !!(organization && workspace && automation && guideEntrie),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listGuideEntryVersions>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListGuideEntryVersionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listGuideEntryVersions>>
>;
export type ListGuideEntryVersionsQueryError = AxiosError<RpcStatus>;

export function useListGuideEntryVersions<
  TData = Awaited<ReturnType<typeof listGuideEntryVersions>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  guideEntrie: string,
  params: undefined | ListGuideEntryVersionsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listGuideEntryVersions>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listGuideEntryVersions>>,
          TError,
          Awaited<ReturnType<typeof listGuideEntryVersions>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListGuideEntryVersions<
  TData = Awaited<ReturnType<typeof listGuideEntryVersions>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  guideEntrie: string,
  params?: ListGuideEntryVersionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listGuideEntryVersions>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listGuideEntryVersions>>,
          TError,
          Awaited<ReturnType<typeof listGuideEntryVersions>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListGuideEntryVersions<
  TData = Awaited<ReturnType<typeof listGuideEntryVersions>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  guideEntrie: string,
  params?: ListGuideEntryVersionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listGuideEntryVersions>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Lists all versions of a guide entry, newest first (by DESC version order).
Unlike GetGuideEntry/ListGuideEntries (which return only the effective
version per entry), this returns the full version history for a single
guide entry so clients can inspect and revert to a previous version.
 */

export function useListGuideEntryVersions<
  TData = Awaited<ReturnType<typeof listGuideEntryVersions>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  guideEntrie: string,
  params?: ListGuideEntryVersionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listGuideEntryVersions>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getListGuideEntryVersionsQueryOptions(
    organization,
    workspace,
    automation,
    guideEntrie,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Reverts a guide entry to a previous version.
Forward-only (like grimoire's RestoreAutomation): copies the target
version's content into a NEW version row with a bumped minor version and
state = PENDING_APPROVAL. No rows are removed and no pointer is moved
backward. Like an ordinary update, the new version becomes the latest
version but must be approved before the agent auto-applies it. The new
version records which version it was reverted from.
 */
export const revertGuideEntry = (
  organization: string,
  workspace: string,
  automation: string,
  guideEntrie: string,
  troubleshootingGuideServiceRevertGuideEntryBody: TroubleshootingGuideServiceRevertGuideEntryBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1GuideEntry>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/guideEntries/${guideEntrie}:revert`,
    troubleshootingGuideServiceRevertGuideEntryBody,
    options,
  );
};

export const getRevertGuideEntryMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof revertGuideEntry>>,
    TError,
    {
      organization: string;
      workspace: string;
      automation: string;
      guideEntrie: string;
      data: TroubleshootingGuideServiceRevertGuideEntryBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof revertGuideEntry>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    guideEntrie: string;
    data: TroubleshootingGuideServiceRevertGuideEntryBody;
  },
  TContext
> => {
  const mutationKey = ['revertGuideEntry'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof revertGuideEntry>>,
    {
      organization: string;
      workspace: string;
      automation: string;
      guideEntrie: string;
      data: TroubleshootingGuideServiceRevertGuideEntryBody;
    }
  > = props => {
    const { organization, workspace, automation, guideEntrie, data } =
      props ?? {};

    return revertGuideEntry(
      organization,
      workspace,
      automation,
      guideEntrie,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type RevertGuideEntryMutationResult = NonNullable<
  Awaited<ReturnType<typeof revertGuideEntry>>
>;
export type RevertGuideEntryMutationBody =
  TroubleshootingGuideServiceRevertGuideEntryBody;
export type RevertGuideEntryMutationError = AxiosError<RpcStatus>;

/**
 * @summary Reverts a guide entry to a previous version.
Forward-only (like grimoire's RestoreAutomation): copies the target
version's content into a NEW version row with a bumped minor version and
state = PENDING_APPROVAL. No rows are removed and no pointer is moved
backward. Like an ordinary update, the new version becomes the latest
version but must be approved before the agent auto-applies it. The new
version records which version it was reverted from.
 */
export const useRevertGuideEntry = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof revertGuideEntry>>,
      TError,
      {
        organization: string;
        workspace: string;
        automation: string;
        guideEntrie: string;
        data: TroubleshootingGuideServiceRevertGuideEntryBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof revertGuideEntry>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    guideEntrie: string;
    data: TroubleshootingGuideServiceRevertGuideEntryBody;
  },
  TContext
> => {
  const mutationOptions = getRevertGuideEntryMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Transitions a guide entry to a new state.
- PENDING_APPROVAL -> APPROVED: Approve the guide entry for use by the agent
- PENDING_APPROVAL -> REJECTED: Reject the guide entry
- Any state -> ARCHIVED: Archive the guide entry (soft deletes and updates the delete time)
 */
export const transitionGuideEntryState = (
  organization: string,
  workspace: string,
  automation: string,
  guideEntrie: string,
  troubleshootingGuideServiceTransitionGuideEntryStateBody: TroubleshootingGuideServiceTransitionGuideEntryStateBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1GuideEntry>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/guideEntries/${guideEntrie}:transitionState`,
    troubleshootingGuideServiceTransitionGuideEntryStateBody,
    options,
  );
};

export const getTransitionGuideEntryStateMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof transitionGuideEntryState>>,
    TError,
    {
      organization: string;
      workspace: string;
      automation: string;
      guideEntrie: string;
      data: TroubleshootingGuideServiceTransitionGuideEntryStateBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof transitionGuideEntryState>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    guideEntrie: string;
    data: TroubleshootingGuideServiceTransitionGuideEntryStateBody;
  },
  TContext
> => {
  const mutationKey = ['transitionGuideEntryState'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof transitionGuideEntryState>>,
    {
      organization: string;
      workspace: string;
      automation: string;
      guideEntrie: string;
      data: TroubleshootingGuideServiceTransitionGuideEntryStateBody;
    }
  > = props => {
    const { organization, workspace, automation, guideEntrie, data } =
      props ?? {};

    return transitionGuideEntryState(
      organization,
      workspace,
      automation,
      guideEntrie,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type TransitionGuideEntryStateMutationResult = NonNullable<
  Awaited<ReturnType<typeof transitionGuideEntryState>>
>;
export type TransitionGuideEntryStateMutationBody =
  TroubleshootingGuideServiceTransitionGuideEntryStateBody;
export type TransitionGuideEntryStateMutationError = AxiosError<RpcStatus>;

/**
 * @summary Transitions a guide entry to a new state.
- PENDING_APPROVAL -> APPROVED: Approve the guide entry for use by the agent
- PENDING_APPROVAL -> REJECTED: Reject the guide entry
- Any state -> ARCHIVED: Archive the guide entry (soft deletes and updates the delete time)
 */
export const useTransitionGuideEntryState = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof transitionGuideEntryState>>,
      TError,
      {
        organization: string;
        workspace: string;
        automation: string;
        guideEntrie: string;
        data: TroubleshootingGuideServiceTransitionGuideEntryStateBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof transitionGuideEntryState>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    guideEntrie: string;
    data: TroubleshootingGuideServiceTransitionGuideEntryStateBody;
  },
  TContext
> => {
  const mutationOptions = getTransitionGuideEntryStateMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Queries usage statistics for guide entries.
Returns aggregated statistics including total occurrences
and filtered occurrences within an optional date range.
This is a custom method for analytics/reporting, not a standard List operation.
 */
export const queryGuideStats = (
  organization: string,
  workspace: string,
  automation: string,
  troubleshootingGuideServiceQueryGuideStatsBody: TroubleshootingGuideServiceQueryGuideStatsBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1QueryGuideStatsResponse>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/guideEntries:queryStats`,
    troubleshootingGuideServiceQueryGuideStatsBody,
    options,
  );
};

export const getQueryGuideStatsMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof queryGuideStats>>,
    TError,
    {
      organization: string;
      workspace: string;
      automation: string;
      data: TroubleshootingGuideServiceQueryGuideStatsBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof queryGuideStats>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    data: TroubleshootingGuideServiceQueryGuideStatsBody;
  },
  TContext
> => {
  const mutationKey = ['queryGuideStats'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof queryGuideStats>>,
    {
      organization: string;
      workspace: string;
      automation: string;
      data: TroubleshootingGuideServiceQueryGuideStatsBody;
    }
  > = props => {
    const { organization, workspace, automation, data } = props ?? {};

    return queryGuideStats(
      organization,
      workspace,
      automation,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type QueryGuideStatsMutationResult = NonNullable<
  Awaited<ReturnType<typeof queryGuideStats>>
>;
export type QueryGuideStatsMutationBody =
  TroubleshootingGuideServiceQueryGuideStatsBody;
export type QueryGuideStatsMutationError = AxiosError<RpcStatus>;

/**
 * @summary Queries usage statistics for guide entries.
Returns aggregated statistics including total occurrences
and filtered occurrences within an optional date range.
This is a custom method for analytics/reporting, not a standard List operation.
 */
export const useQueryGuideStats = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof queryGuideStats>>,
      TError,
      {
        organization: string;
        workspace: string;
        automation: string;
        data: TroubleshootingGuideServiceQueryGuideStatsBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof queryGuideStats>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    data: TroubleshootingGuideServiceQueryGuideStatsBody;
  },
  TContext
> => {
  const mutationOptions = getQueryGuideStatsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Lists events in a run's conversation thread.
 */
export const listEvents = (
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  agent: string,
  params?: ListEventsParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1ListEventsResponse>> => {
  return axios.default.get(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/runs/${run}/agents/${agent}/events`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getListEventsQueryKey = (
  organization?: string,
  workspace?: string,
  automation?: string,
  run?: string,
  agent?: string,
  params?: ListEventsParams,
) => {
  return [
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/runs/${run}/agents/${agent}/events`,
    ...(params ? [params] : []),
  ] as const;
};

export const getListEventsQueryOptions = <
  TData = Awaited<ReturnType<typeof listEvents>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  agent: string,
  params?: ListEventsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listEvents>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListEventsQueryKey(
      organization,
      workspace,
      automation,
      run,
      agent,
      params,
    );

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listEvents>>> = ({
    signal,
  }) =>
    listEvents(organization, workspace, automation, run, agent, params, {
      signal,
      ...axiosOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled: !!(organization && workspace && automation && run && agent),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listEvents>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListEventsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listEvents>>
>;
export type ListEventsQueryError = AxiosError<RpcStatus>;

export function useListEvents<
  TData = Awaited<ReturnType<typeof listEvents>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  agent: string,
  params: undefined | ListEventsParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listEvents>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listEvents>>,
          TError,
          Awaited<ReturnType<typeof listEvents>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListEvents<
  TData = Awaited<ReturnType<typeof listEvents>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  agent: string,
  params?: ListEventsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listEvents>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listEvents>>,
          TError,
          Awaited<ReturnType<typeof listEvents>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListEvents<
  TData = Awaited<ReturnType<typeof listEvents>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  agent: string,
  params?: ListEventsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listEvents>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Lists events in a run's conversation thread.
 */

export function useListEvents<
  TData = Awaited<ReturnType<typeof listEvents>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  agent: string,
  params?: ListEventsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listEvents>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getListEventsQueryOptions(
    organization,
    workspace,
    automation,
    run,
    agent,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Creates an event in a run's conversation thread.
Only user messages can be created via this API. The AI agent will automatically
respond by creating agent messages, tool calls, thinking events, etc.
 */
export const createEvent = (
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  agent: string,
  v1Event: NonReadonly<V1Event>,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1Event>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/runs/${run}/agents/${agent}/events`,
    v1Event,
    options,
  );
};

export const getCreateEventMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createEvent>>,
    TError,
    {
      organization: string;
      workspace: string;
      automation: string;
      run: string;
      agent: string;
      data: NonReadonly<V1Event>;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createEvent>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    run: string;
    agent: string;
    data: NonReadonly<V1Event>;
  },
  TContext
> => {
  const mutationKey = ['createEvent'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createEvent>>,
    {
      organization: string;
      workspace: string;
      automation: string;
      run: string;
      agent: string;
      data: NonReadonly<V1Event>;
    }
  > = props => {
    const { organization, workspace, automation, run, agent, data } =
      props ?? {};

    return createEvent(
      organization,
      workspace,
      automation,
      run,
      agent,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateEventMutationResult = NonNullable<
  Awaited<ReturnType<typeof createEvent>>
>;
export type CreateEventMutationBody = NonReadonly<V1Event>;
export type CreateEventMutationError = AxiosError<RpcStatus>;

/**
 * @summary Creates an event in a run's conversation thread.
Only user messages can be created via this API. The AI agent will automatically
respond by creating agent messages, tool calls, thinking events, etc.
 */
export const useCreateEvent = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createEvent>>,
      TError,
      {
        organization: string;
        workspace: string;
        automation: string;
        run: string;
        agent: string;
        data: NonReadonly<V1Event>;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createEvent>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    run: string;
    agent: string;
    data: NonReadonly<V1Event>;
  },
  TContext
> => {
  const mutationOptions = getCreateEventMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Gets an event by its resource name.
 */
export const getEvent = (
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  agent: string,
  event: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1Event>> => {
  return axios.default.get(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/runs/${run}/agents/${agent}/events/${event}`,
    options,
  );
};

export const getGetEventQueryKey = (
  organization?: string,
  workspace?: string,
  automation?: string,
  run?: string,
  agent?: string,
  event?: string,
) => {
  return [
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/runs/${run}/agents/${agent}/events/${event}`,
  ] as const;
};

export const getGetEventQueryOptions = <
  TData = Awaited<ReturnType<typeof getEvent>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  agent: string,
  event: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEvent>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetEventQueryKey(organization, workspace, automation, run, agent, event);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getEvent>>> = ({
    signal,
  }) =>
    getEvent(organization, workspace, automation, run, agent, event, {
      signal,
      ...axiosOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled: !!(
      organization &&
      workspace &&
      automation &&
      run &&
      agent &&
      event
    ),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getEvent>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type GetEventQueryResult = NonNullable<
  Awaited<ReturnType<typeof getEvent>>
>;
export type GetEventQueryError = AxiosError<RpcStatus>;

export function useGetEvent<
  TData = Awaited<ReturnType<typeof getEvent>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  agent: string,
  event: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEvent>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEvent>>,
          TError,
          Awaited<ReturnType<typeof getEvent>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetEvent<
  TData = Awaited<ReturnType<typeof getEvent>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  agent: string,
  event: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEvent>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEvent>>,
          TError,
          Awaited<ReturnType<typeof getEvent>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetEvent<
  TData = Awaited<ReturnType<typeof getEvent>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  agent: string,
  event: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEvent>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Gets an event by its resource name.
 */

export function useGetEvent<
  TData = Awaited<ReturnType<typeof getEvent>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  agent: string,
  event: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEvent>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetEventQueryOptions(
    organization,
    workspace,
    automation,
    run,
    agent,
    event,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Cancels ongoing event generation in a run's conversation thread.
This stops the AI agent from generating further automatic events (agent messages,
tool calls, thinking, etc.) for the current conversation turn.
 */
export const cancelGeneration = (
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  agent: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1CancelGenerationResponse>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/runs/${run}/agents/${agent}/events:cancelGeneration`,
    undefined,
    options,
  );
};

export const getCancelGenerationMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof cancelGeneration>>,
    TError,
    {
      organization: string;
      workspace: string;
      automation: string;
      run: string;
      agent: string;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof cancelGeneration>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    run: string;
    agent: string;
  },
  TContext
> => {
  const mutationKey = ['cancelGeneration'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof cancelGeneration>>,
    {
      organization: string;
      workspace: string;
      automation: string;
      run: string;
      agent: string;
    }
  > = props => {
    const { organization, workspace, automation, run, agent } = props ?? {};

    return cancelGeneration(
      organization,
      workspace,
      automation,
      run,
      agent,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type CancelGenerationMutationResult = NonNullable<
  Awaited<ReturnType<typeof cancelGeneration>>
>;

export type CancelGenerationMutationError = AxiosError<RpcStatus>;

/**
 * @summary Cancels ongoing event generation in a run's conversation thread.
This stops the AI agent from generating further automatic events (agent messages,
tool calls, thinking, etc.) for the current conversation turn.
 */
export const useCancelGeneration = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof cancelGeneration>>,
      TError,
      {
        organization: string;
        workspace: string;
        automation: string;
        run: string;
        agent: string;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof cancelGeneration>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    run: string;
    agent: string;
  },
  TContext
> => {
  const mutationOptions = getCancelGenerationMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Subscribes to events in a run's conversation thread.
Returns a stream of events as they are created or updated.
Events include user messages, agent messages, tool calls, thinking, and system messages.
 */
export const streamEvents = (
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  agent: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<Blob>> => {
  return axios.default.get(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/runs/${run}/agents/${agent}/events:stream`,
    {
      responseType: 'blob',
      ...options,
    },
  );
};

export const getStreamEventsQueryKey = (
  organization?: string,
  workspace?: string,
  automation?: string,
  run?: string,
  agent?: string,
) => {
  return [
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/runs/${run}/agents/${agent}/events:stream`,
  ] as const;
};

export const getStreamEventsQueryOptions = <
  TData = Awaited<ReturnType<typeof streamEvents>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  agent: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof streamEvents>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getStreamEventsQueryKey(organization, workspace, automation, run, agent);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof streamEvents>>> = ({
    signal,
  }) =>
    streamEvents(organization, workspace, automation, run, agent, {
      signal,
      ...axiosOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled: !!(organization && workspace && automation && run && agent),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof streamEvents>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type StreamEventsQueryResult = NonNullable<
  Awaited<ReturnType<typeof streamEvents>>
>;
export type StreamEventsQueryError = AxiosError<RpcStatus>;

export function useStreamEvents<
  TData = Awaited<ReturnType<typeof streamEvents>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  agent: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof streamEvents>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof streamEvents>>,
          TError,
          Awaited<ReturnType<typeof streamEvents>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useStreamEvents<
  TData = Awaited<ReturnType<typeof streamEvents>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  agent: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof streamEvents>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof streamEvents>>,
          TError,
          Awaited<ReturnType<typeof streamEvents>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useStreamEvents<
  TData = Awaited<ReturnType<typeof streamEvents>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  agent: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof streamEvents>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Subscribes to events in a run's conversation thread.
Returns a stream of events as they are created or updated.
Events include user messages, agent messages, tool calls, thinking, and system messages.
 */

export function useStreamEvents<
  TData = Awaited<ReturnType<typeof streamEvents>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  agent: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof streamEvents>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getStreamEventsQueryOptions(
    organization,
    workspace,
    automation,
    run,
    agent,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Creates an interactive AI assistant (a Rain thread) for a run, pre-staged
with the automation's code and connections. Returns the rain_thread_id.
Despite the "Create" prefix this is a custom action, not an AIP-133 standard
Create: it has no resource body (the only input is the parent run, bound from
the path) and returns a thread id rather than a resource.
 */
export const createRunAssistant = (
  organization: string,
  workspace: string,
  automation: string,
  run: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1CreateRunAssistantResponse>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/runs/${run}:runAssistant`,
    undefined,
    options,
  );
};

export const getCreateRunAssistantMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createRunAssistant>>,
    TError,
    {
      organization: string;
      workspace: string;
      automation: string;
      run: string;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createRunAssistant>>,
  TError,
  { organization: string; workspace: string; automation: string; run: string },
  TContext
> => {
  const mutationKey = ['createRunAssistant'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createRunAssistant>>,
    { organization: string; workspace: string; automation: string; run: string }
  > = props => {
    const { organization, workspace, automation, run } = props ?? {};

    return createRunAssistant(
      organization,
      workspace,
      automation,
      run,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateRunAssistantMutationResult = NonNullable<
  Awaited<ReturnType<typeof createRunAssistant>>
>;

export type CreateRunAssistantMutationError = AxiosError<RpcStatus>;

/**
 * @summary Creates an interactive AI assistant (a Rain thread) for a run, pre-staged
with the automation's code and connections. Returns the rain_thread_id.
Despite the "Create" prefix this is a custom action, not an AIP-133 standard
Create: it has no resource body (the only input is the parent run, bound from
the path) and returns a thread id rather than a resource.
 */
export const useCreateRunAssistant = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createRunAssistant>>,
      TError,
      {
        organization: string;
        workspace: string;
        automation: string;
        run: string;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createRunAssistant>>,
  TError,
  { organization: string; workspace: string; automation: string; run: string },
  TContext
> => {
  const mutationOptions = getCreateRunAssistantMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Lists exception clusters -- one row per distinct symptom, aggregated
server-side so a client never has to hold every exception to group them.
A cluster is (automation, automation_version, cluster label): a fix ships
as a new version, so the same symptom on two versions is two problems.
Clusters are derived from Exception.cluster rather than stored, so they are
not yet resources; ExceptionGroup sets the same precedent.
 */
export const listExceptionClusters = (
  organization: string,
  workspace: string,
  params?: ListExceptionClustersParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1ListExceptionClustersResponse>> => {
  return axios.default.get(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/exceptionClusters`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getListExceptionClustersQueryKey = (
  organization?: string,
  workspace?: string,
  params?: ListExceptionClustersParams,
) => {
  return [
    `/api/v1/organizations/${organization}/workspaces/${workspace}/exceptionClusters`,
    ...(params ? [params] : []),
  ] as const;
};

export const getListExceptionClustersQueryOptions = <
  TData = Awaited<ReturnType<typeof listExceptionClusters>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  params?: ListExceptionClustersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listExceptionClusters>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListExceptionClustersQueryKey(organization, workspace, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listExceptionClusters>>
  > = ({ signal }) =>
    listExceptionClusters(organization, workspace, params, {
      signal,
      ...axiosOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled: !!(organization && workspace),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listExceptionClusters>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListExceptionClustersQueryResult = NonNullable<
  Awaited<ReturnType<typeof listExceptionClusters>>
>;
export type ListExceptionClustersQueryError = AxiosError<RpcStatus>;

export function useListExceptionClusters<
  TData = Awaited<ReturnType<typeof listExceptionClusters>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  params: undefined | ListExceptionClustersParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listExceptionClusters>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listExceptionClusters>>,
          TError,
          Awaited<ReturnType<typeof listExceptionClusters>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListExceptionClusters<
  TData = Awaited<ReturnType<typeof listExceptionClusters>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  params?: ListExceptionClustersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listExceptionClusters>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listExceptionClusters>>,
          TError,
          Awaited<ReturnType<typeof listExceptionClusters>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListExceptionClusters<
  TData = Awaited<ReturnType<typeof listExceptionClusters>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  params?: ListExceptionClustersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listExceptionClusters>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Lists exception clusters -- one row per distinct symptom, aggregated
server-side so a client never has to hold every exception to group them.
A cluster is (automation, automation_version, cluster label): a fix ships
as a new version, so the same symptom on two versions is two problems.
Clusters are derived from Exception.cluster rather than stored, so they are
not yet resources; ExceptionGroup sets the same precedent.
 */

export function useListExceptionClusters<
  TData = Awaited<ReturnType<typeof listExceptionClusters>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  params?: ListExceptionClustersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listExceptionClusters>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getListExceptionClustersQueryOptions(
    organization,
    workspace,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Lists available exception groups
These groups are static and defined by the system (for now).
Use this to populate UI dropdowns and display group descriptions.
 */
export const listExceptionGroups = (
  organization: string,
  workspace: string,
  params?: ListExceptionGroupsParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1ListExceptionGroupsResponse>> => {
  return axios.default.get(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/exceptionGroups`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getListExceptionGroupsQueryKey = (
  organization?: string,
  workspace?: string,
  params?: ListExceptionGroupsParams,
) => {
  return [
    `/api/v1/organizations/${organization}/workspaces/${workspace}/exceptionGroups`,
    ...(params ? [params] : []),
  ] as const;
};

export const getListExceptionGroupsQueryOptions = <
  TData = Awaited<ReturnType<typeof listExceptionGroups>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  params?: ListExceptionGroupsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listExceptionGroups>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListExceptionGroupsQueryKey(organization, workspace, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listExceptionGroups>>
  > = ({ signal }) =>
    listExceptionGroups(organization, workspace, params, {
      signal,
      ...axiosOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled: !!(organization && workspace),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listExceptionGroups>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListExceptionGroupsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listExceptionGroups>>
>;
export type ListExceptionGroupsQueryError = AxiosError<RpcStatus>;

export function useListExceptionGroups<
  TData = Awaited<ReturnType<typeof listExceptionGroups>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  params: undefined | ListExceptionGroupsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listExceptionGroups>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listExceptionGroups>>,
          TError,
          Awaited<ReturnType<typeof listExceptionGroups>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListExceptionGroups<
  TData = Awaited<ReturnType<typeof listExceptionGroups>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  params?: ListExceptionGroupsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listExceptionGroups>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listExceptionGroups>>,
          TError,
          Awaited<ReturnType<typeof listExceptionGroups>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListExceptionGroups<
  TData = Awaited<ReturnType<typeof listExceptionGroups>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  params?: ListExceptionGroupsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listExceptionGroups>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Lists available exception groups
These groups are static and defined by the system (for now).
Use this to populate UI dropdowns and display group descriptions.
 */

export function useListExceptionGroups<
  TData = Awaited<ReturnType<typeof listExceptionGroups>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  params?: ListExceptionGroupsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listExceptionGroups>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getListExceptionGroupsQueryOptions(
    organization,
    workspace,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Sets default assignees for exception groups in a workspace.
Sets or clears the default assignee for one or more exception groups.
When a default assignee is set for a group, new exceptions in that group
will be automatically assigned to that user at creation time.
Set default_assignee to "" to clear the default (no auto-assignment).
 */
export const setExceptionGroupRouting = (
  organization: string,
  workspace: string,
  exceptionManagerServiceSetExceptionGroupRoutingBody: ExceptionManagerServiceSetExceptionGroupRoutingBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1SetExceptionGroupRoutingResponse>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/exceptionGroups:setRouting`,
    exceptionManagerServiceSetExceptionGroupRoutingBody,
    options,
  );
};

export const getSetExceptionGroupRoutingMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof setExceptionGroupRouting>>,
    TError,
    {
      organization: string;
      workspace: string;
      data: ExceptionManagerServiceSetExceptionGroupRoutingBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof setExceptionGroupRouting>>,
  TError,
  {
    organization: string;
    workspace: string;
    data: ExceptionManagerServiceSetExceptionGroupRoutingBody;
  },
  TContext
> => {
  const mutationKey = ['setExceptionGroupRouting'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof setExceptionGroupRouting>>,
    {
      organization: string;
      workspace: string;
      data: ExceptionManagerServiceSetExceptionGroupRoutingBody;
    }
  > = props => {
    const { organization, workspace, data } = props ?? {};

    return setExceptionGroupRouting(
      organization,
      workspace,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type SetExceptionGroupRoutingMutationResult = NonNullable<
  Awaited<ReturnType<typeof setExceptionGroupRouting>>
>;
export type SetExceptionGroupRoutingMutationBody =
  ExceptionManagerServiceSetExceptionGroupRoutingBody;
export type SetExceptionGroupRoutingMutationError = AxiosError<RpcStatus>;

/**
 * @summary Sets default assignees for exception groups in a workspace.
Sets or clears the default assignee for one or more exception groups.
When a default assignee is set for a group, new exceptions in that group
will be automatically assigned to that user at creation time.
Set default_assignee to "" to clear the default (no auto-assignment).
 */
export const useSetExceptionGroupRouting = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof setExceptionGroupRouting>>,
      TError,
      {
        organization: string;
        workspace: string;
        data: ExceptionManagerServiceSetExceptionGroupRoutingBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof setExceptionGroupRouting>>,
  TError,
  {
    organization: string;
    workspace: string;
    data: ExceptionManagerServiceSetExceptionGroupRoutingBody;
  },
  TContext
> => {
  const mutationOptions = getSetExceptionGroupRoutingMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Lists exceptions for a given workspace.
 */
export const listExceptions = (
  organization: string,
  workspace: string,
  params?: ListExceptionsParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1ListExceptionsResponse>> => {
  return axios.default.get(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/exceptions`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getListExceptionsInfiniteQueryKey = (
  organization?: string,
  workspace?: string,
  params?: ListExceptionsParams,
) => {
  return [
    'infinite',
    `/api/v1/organizations/${organization}/workspaces/${workspace}/exceptions`,
    ...(params ? [params] : []),
  ] as const;
};

export const getListExceptionsQueryKey = (
  organization?: string,
  workspace?: string,
  params?: ListExceptionsParams,
) => {
  return [
    `/api/v1/organizations/${organization}/workspaces/${workspace}/exceptions`,
    ...(params ? [params] : []),
  ] as const;
};

export const getListExceptionsInfiniteQueryOptions = <
  TData = InfiniteData<
    Awaited<ReturnType<typeof listExceptions>>,
    ListExceptionsParams['page_token']
  >,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  params?: ListExceptionsParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof listExceptions>>,
        TError,
        TData,
        QueryKey,
        ListExceptionsParams['page_token']
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListExceptionsInfiniteQueryKey(organization, workspace, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listExceptions>>,
    QueryKey,
    ListExceptionsParams['page_token']
  > = ({ signal, pageParam }) =>
    listExceptions(
      organization,
      workspace,
      { ...params, page_token: pageParam || params?.['page_token'] },
      { signal, ...axiosOptions },
    );

  return {
    queryKey,
    queryFn,
    enabled: !!(organization && workspace),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof listExceptions>>,
    TError,
    TData,
    QueryKey,
    ListExceptionsParams['page_token']
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListExceptionsInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof listExceptions>>
>;
export type ListExceptionsInfiniteQueryError = AxiosError<RpcStatus>;

export function useListExceptionsInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof listExceptions>>,
    ListExceptionsParams['page_token']
  >,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  params: undefined | ListExceptionsParams,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof listExceptions>>,
        TError,
        TData,
        QueryKey,
        ListExceptionsParams['page_token']
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listExceptions>>,
          TError,
          Awaited<ReturnType<typeof listExceptions>>,
          QueryKey
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListExceptionsInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof listExceptions>>,
    ListExceptionsParams['page_token']
  >,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  params?: ListExceptionsParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof listExceptions>>,
        TError,
        TData,
        QueryKey,
        ListExceptionsParams['page_token']
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listExceptions>>,
          TError,
          Awaited<ReturnType<typeof listExceptions>>,
          QueryKey
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListExceptionsInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof listExceptions>>,
    ListExceptionsParams['page_token']
  >,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  params?: ListExceptionsParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof listExceptions>>,
        TError,
        TData,
        QueryKey,
        ListExceptionsParams['page_token']
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Lists exceptions for a given workspace.
 */

export function useListExceptionsInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof listExceptions>>,
    ListExceptionsParams['page_token']
  >,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  params?: ListExceptionsParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof listExceptions>>,
        TError,
        TData,
        QueryKey,
        ListExceptionsParams['page_token']
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getListExceptionsInfiniteQueryOptions(
    organization,
    workspace,
    params,
    options,
  );

  const query = useInfiniteQuery(
    queryOptions,
    queryClient,
  ) as UseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getListExceptionsQueryOptions = <
  TData = Awaited<ReturnType<typeof listExceptions>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  params?: ListExceptionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listExceptions>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListExceptionsQueryKey(organization, workspace, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listExceptions>>> = ({
    signal,
  }) =>
    listExceptions(organization, workspace, params, {
      signal,
      ...axiosOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled: !!(organization && workspace),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listExceptions>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListExceptionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listExceptions>>
>;
export type ListExceptionsQueryError = AxiosError<RpcStatus>;

export function useListExceptions<
  TData = Awaited<ReturnType<typeof listExceptions>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  params: undefined | ListExceptionsParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listExceptions>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listExceptions>>,
          TError,
          Awaited<ReturnType<typeof listExceptions>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListExceptions<
  TData = Awaited<ReturnType<typeof listExceptions>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  params?: ListExceptionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listExceptions>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listExceptions>>,
          TError,
          Awaited<ReturnType<typeof listExceptions>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListExceptions<
  TData = Awaited<ReturnType<typeof listExceptions>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  params?: ListExceptionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listExceptions>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Lists exceptions for a given workspace.
 */

export function useListExceptions<
  TData = Awaited<ReturnType<typeof listExceptions>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  params?: ListExceptionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listExceptions>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getListExceptionsQueryOptions(
    organization,
    workspace,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Creates an exception for an automation run.
 */
export const createException = (
  organization: string,
  workspace: string,
  v1Exception: NonReadonly<V1Exception>,
  params?: CreateExceptionParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1Exception>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/exceptions`,
    v1Exception,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getCreateExceptionMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createException>>,
    TError,
    {
      organization: string;
      workspace: string;
      data: NonReadonly<V1Exception>;
      params?: CreateExceptionParams;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createException>>,
  TError,
  {
    organization: string;
    workspace: string;
    data: NonReadonly<V1Exception>;
    params?: CreateExceptionParams;
  },
  TContext
> => {
  const mutationKey = ['createException'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createException>>,
    {
      organization: string;
      workspace: string;
      data: NonReadonly<V1Exception>;
      params?: CreateExceptionParams;
    }
  > = props => {
    const { organization, workspace, data, params } = props ?? {};

    return createException(organization, workspace, data, params, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateExceptionMutationResult = NonNullable<
  Awaited<ReturnType<typeof createException>>
>;
export type CreateExceptionMutationBody = NonReadonly<V1Exception>;
export type CreateExceptionMutationError = AxiosError<RpcStatus>;

/**
 * @summary Creates an exception for an automation run.
 */
export const useCreateException = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createException>>,
      TError,
      {
        organization: string;
        workspace: string;
        data: NonReadonly<V1Exception>;
        params?: CreateExceptionParams;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createException>>,
  TError,
  {
    organization: string;
    workspace: string;
    data: NonReadonly<V1Exception>;
    params?: CreateExceptionParams;
  },
  TContext
> => {
  const mutationOptions = getCreateExceptionMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Gets an exception by its resource name.
 */
export const getException = (
  organization: string,
  workspace: string,
  exception: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1Exception>> => {
  return axios.default.get(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/exceptions/${exception}`,
    options,
  );
};

export const getGetExceptionQueryKey = (
  organization?: string,
  workspace?: string,
  exception?: string,
) => {
  return [
    `/api/v1/organizations/${organization}/workspaces/${workspace}/exceptions/${exception}`,
  ] as const;
};

export const getGetExceptionQueryOptions = <
  TData = Awaited<ReturnType<typeof getException>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  exception: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getException>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetExceptionQueryKey(organization, workspace, exception);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getException>>> = ({
    signal,
  }) =>
    getException(organization, workspace, exception, {
      signal,
      ...axiosOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled: !!(organization && workspace && exception),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getException>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetExceptionQueryResult = NonNullable<
  Awaited<ReturnType<typeof getException>>
>;
export type GetExceptionQueryError = AxiosError<RpcStatus>;

export function useGetException<
  TData = Awaited<ReturnType<typeof getException>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  exception: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getException>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getException>>,
          TError,
          Awaited<ReturnType<typeof getException>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetException<
  TData = Awaited<ReturnType<typeof getException>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  exception: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getException>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getException>>,
          TError,
          Awaited<ReturnType<typeof getException>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetException<
  TData = Awaited<ReturnType<typeof getException>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  exception: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getException>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Gets an exception by its resource name.
 */

export function useGetException<
  TData = Awaited<ReturnType<typeof getException>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  exception: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getException>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetExceptionQueryOptions(
    organization,
    workspace,
    exception,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Hermes has no tool for reading the exception it was raised on, so this
payload IS its knowledge of what failed: the interpreter message, the
failing location, the variables the failing statement read and the values
they held, the run's inputs, and a window of the source around the line
that raised. The caller opens the Rain thread itself and sends this as (or
ahead of) the operator's first message.

Read-only and idempotent, so a caller that lost the payload -- a page
reload, a second browser tab -- asks again rather than reconstructing it.
That is the point: the payload lives here, not in whatever opened the
thread.
 * @summary Returns the opening `<exception>` payload for the Hermes agent.
 */
export const getHermesExceptionContext = (
  organization: string,
  workspace: string,
  exception: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1GetHermesExceptionContextResponse>> => {
  return axios.default.get(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/exceptions/${exception}:hermesContext`,
    options,
  );
};

export const getGetHermesExceptionContextQueryKey = (
  organization?: string,
  workspace?: string,
  exception?: string,
) => {
  return [
    `/api/v1/organizations/${organization}/workspaces/${workspace}/exceptions/${exception}:hermesContext`,
  ] as const;
};

export const getGetHermesExceptionContextQueryOptions = <
  TData = Awaited<ReturnType<typeof getHermesExceptionContext>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  exception: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getHermesExceptionContext>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetHermesExceptionContextQueryKey(organization, workspace, exception);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getHermesExceptionContext>>
  > = ({ signal }) =>
    getHermesExceptionContext(organization, workspace, exception, {
      signal,
      ...axiosOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled: !!(organization && workspace && exception),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getHermesExceptionContext>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetHermesExceptionContextQueryResult = NonNullable<
  Awaited<ReturnType<typeof getHermesExceptionContext>>
>;
export type GetHermesExceptionContextQueryError = AxiosError<RpcStatus>;

export function useGetHermesExceptionContext<
  TData = Awaited<ReturnType<typeof getHermesExceptionContext>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  exception: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getHermesExceptionContext>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getHermesExceptionContext>>,
          TError,
          Awaited<ReturnType<typeof getHermesExceptionContext>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetHermesExceptionContext<
  TData = Awaited<ReturnType<typeof getHermesExceptionContext>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  exception: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getHermesExceptionContext>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getHermesExceptionContext>>,
          TError,
          Awaited<ReturnType<typeof getHermesExceptionContext>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetHermesExceptionContext<
  TData = Awaited<ReturnType<typeof getHermesExceptionContext>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  exception: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getHermesExceptionContext>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Returns the opening `<exception>` payload for the Hermes agent.
 */

export function useGetHermesExceptionContext<
  TData = Awaited<ReturnType<typeof getHermesExceptionContext>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  exception: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getHermesExceptionContext>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetHermesExceptionContextQueryOptions(
    organization,
    workspace,
    exception,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Archives PENDING exceptions matching a filter.
Transitions exceptions from PENDING to ARCHIVED state.
RESOLVED exceptions are ignored (already complete, no need to archive).
Use this when giving up on unresolved exceptions.
 */
export const archiveExceptions = (
  organization: string,
  workspace: string,
  exceptionManagerServiceArchiveExceptionsBody: ExceptionManagerServiceArchiveExceptionsBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1ArchiveExceptionsResponse>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/exceptions:archive`,
    exceptionManagerServiceArchiveExceptionsBody,
    options,
  );
};

export const getArchiveExceptionsMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof archiveExceptions>>,
    TError,
    {
      organization: string;
      workspace: string;
      data: ExceptionManagerServiceArchiveExceptionsBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof archiveExceptions>>,
  TError,
  {
    organization: string;
    workspace: string;
    data: ExceptionManagerServiceArchiveExceptionsBody;
  },
  TContext
> => {
  const mutationKey = ['archiveExceptions'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof archiveExceptions>>,
    {
      organization: string;
      workspace: string;
      data: ExceptionManagerServiceArchiveExceptionsBody;
    }
  > = props => {
    const { organization, workspace, data } = props ?? {};

    return archiveExceptions(organization, workspace, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ArchiveExceptionsMutationResult = NonNullable<
  Awaited<ReturnType<typeof archiveExceptions>>
>;
export type ArchiveExceptionsMutationBody =
  ExceptionManagerServiceArchiveExceptionsBody;
export type ArchiveExceptionsMutationError = AxiosError<RpcStatus>;

/**
 * @summary Archives PENDING exceptions matching a filter.
Transitions exceptions from PENDING to ARCHIVED state.
RESOLVED exceptions are ignored (already complete, no need to archive).
Use this when giving up on unresolved exceptions.
 */
export const useArchiveExceptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof archiveExceptions>>,
      TError,
      {
        organization: string;
        workspace: string;
        data: ExceptionManagerServiceArchiveExceptionsBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof archiveExceptions>>,
  TError,
  {
    organization: string;
    workspace: string;
    data: ExceptionManagerServiceArchiveExceptionsBody;
  },
  TContext
> => {
  const mutationOptions = getArchiveExceptionsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Assigns exceptions to a user.
Supports three assignment scopes:
1. Single exception: set `name` to target one exception.
2. Group + automation: set `filter` with group and automation to target exceptions
   for a specific group within a specific automation.
3. Group + workspace: set `filter` with group only to target all exceptions
   for a group across the entire workspace.
Set `assignee` to "" to clear the assignment.
 */
export const assignExceptions = (
  organization: string,
  workspace: string,
  exceptionManagerServiceAssignExceptionsBody: ExceptionManagerServiceAssignExceptionsBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1AssignExceptionsResponse>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/exceptions:assign`,
    exceptionManagerServiceAssignExceptionsBody,
    options,
  );
};

export const getAssignExceptionsMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof assignExceptions>>,
    TError,
    {
      organization: string;
      workspace: string;
      data: ExceptionManagerServiceAssignExceptionsBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof assignExceptions>>,
  TError,
  {
    organization: string;
    workspace: string;
    data: ExceptionManagerServiceAssignExceptionsBody;
  },
  TContext
> => {
  const mutationKey = ['assignExceptions'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof assignExceptions>>,
    {
      organization: string;
      workspace: string;
      data: ExceptionManagerServiceAssignExceptionsBody;
    }
  > = props => {
    const { organization, workspace, data } = props ?? {};

    return assignExceptions(organization, workspace, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AssignExceptionsMutationResult = NonNullable<
  Awaited<ReturnType<typeof assignExceptions>>
>;
export type AssignExceptionsMutationBody =
  ExceptionManagerServiceAssignExceptionsBody;
export type AssignExceptionsMutationError = AxiosError<RpcStatus>;

/**
 * @summary Assigns exceptions to a user.
Supports three assignment scopes:
1. Single exception: set `name` to target one exception.
2. Group + automation: set `filter` with group and automation to target exceptions
   for a specific group within a specific automation.
3. Group + workspace: set `filter` with group only to target all exceptions
   for a group across the entire workspace.
Set `assignee` to "" to clear the assignment.
 */
export const useAssignExceptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof assignExceptions>>,
      TError,
      {
        organization: string;
        workspace: string;
        data: ExceptionManagerServiceAssignExceptionsBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof assignExceptions>>,
  TError,
  {
    organization: string;
    workspace: string;
    data: ExceptionManagerServiceAssignExceptionsBody;
  },
  TContext
> => {
  const mutationOptions = getAssignExceptionsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Counts exceptions by assignee.
Returns a list of assignees with their exception counts.
Useful for workload distribution dashboards and identifying unassigned exceptions.
 */
export const countExceptionsByAssignee = (
  organization: string,
  workspace: string,
  params?: CountExceptionsByAssigneeParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1CountExceptionsByAssigneeResponse>> => {
  return axios.default.get(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/exceptions:countByAssignee`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getCountExceptionsByAssigneeQueryKey = (
  organization?: string,
  workspace?: string,
  params?: CountExceptionsByAssigneeParams,
) => {
  return [
    `/api/v1/organizations/${organization}/workspaces/${workspace}/exceptions:countByAssignee`,
    ...(params ? [params] : []),
  ] as const;
};

export const getCountExceptionsByAssigneeQueryOptions = <
  TData = Awaited<ReturnType<typeof countExceptionsByAssignee>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  params?: CountExceptionsByAssigneeParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof countExceptionsByAssignee>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getCountExceptionsByAssigneeQueryKey(organization, workspace, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof countExceptionsByAssignee>>
  > = ({ signal }) =>
    countExceptionsByAssignee(organization, workspace, params, {
      signal,
      ...axiosOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled: !!(organization && workspace),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof countExceptionsByAssignee>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type CountExceptionsByAssigneeQueryResult = NonNullable<
  Awaited<ReturnType<typeof countExceptionsByAssignee>>
>;
export type CountExceptionsByAssigneeQueryError = AxiosError<RpcStatus>;

export function useCountExceptionsByAssignee<
  TData = Awaited<ReturnType<typeof countExceptionsByAssignee>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  params: undefined | CountExceptionsByAssigneeParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof countExceptionsByAssignee>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof countExceptionsByAssignee>>,
          TError,
          Awaited<ReturnType<typeof countExceptionsByAssignee>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useCountExceptionsByAssignee<
  TData = Awaited<ReturnType<typeof countExceptionsByAssignee>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  params?: CountExceptionsByAssigneeParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof countExceptionsByAssignee>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof countExceptionsByAssignee>>,
          TError,
          Awaited<ReturnType<typeof countExceptionsByAssignee>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useCountExceptionsByAssignee<
  TData = Awaited<ReturnType<typeof countExceptionsByAssignee>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  params?: CountExceptionsByAssigneeParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof countExceptionsByAssignee>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Counts exceptions by assignee.
Returns a list of assignees with their exception counts.
Useful for workload distribution dashboards and identifying unassigned exceptions.
 */

export function useCountExceptionsByAssignee<
  TData = Awaited<ReturnType<typeof countExceptionsByAssignee>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  params?: CountExceptionsByAssigneeParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof countExceptionsByAssignee>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getCountExceptionsByAssigneeQueryOptions(
    organization,
    workspace,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Counts exceptions by automation.
Returns a list of automations with their exception counts.
Useful for identifying which automations have the most exceptions.
 */
export const countExceptionsByAutomation = (
  organization: string,
  workspace: string,
  params?: CountExceptionsByAutomationParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1CountExceptionsByAutomationResponse>> => {
  return axios.default.get(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/exceptions:countByAutomation`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getCountExceptionsByAutomationQueryKey = (
  organization?: string,
  workspace?: string,
  params?: CountExceptionsByAutomationParams,
) => {
  return [
    `/api/v1/organizations/${organization}/workspaces/${workspace}/exceptions:countByAutomation`,
    ...(params ? [params] : []),
  ] as const;
};

export const getCountExceptionsByAutomationQueryOptions = <
  TData = Awaited<ReturnType<typeof countExceptionsByAutomation>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  params?: CountExceptionsByAutomationParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof countExceptionsByAutomation>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getCountExceptionsByAutomationQueryKey(organization, workspace, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof countExceptionsByAutomation>>
  > = ({ signal }) =>
    countExceptionsByAutomation(organization, workspace, params, {
      signal,
      ...axiosOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled: !!(organization && workspace),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof countExceptionsByAutomation>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type CountExceptionsByAutomationQueryResult = NonNullable<
  Awaited<ReturnType<typeof countExceptionsByAutomation>>
>;
export type CountExceptionsByAutomationQueryError = AxiosError<RpcStatus>;

export function useCountExceptionsByAutomation<
  TData = Awaited<ReturnType<typeof countExceptionsByAutomation>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  params: undefined | CountExceptionsByAutomationParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof countExceptionsByAutomation>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof countExceptionsByAutomation>>,
          TError,
          Awaited<ReturnType<typeof countExceptionsByAutomation>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useCountExceptionsByAutomation<
  TData = Awaited<ReturnType<typeof countExceptionsByAutomation>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  params?: CountExceptionsByAutomationParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof countExceptionsByAutomation>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof countExceptionsByAutomation>>,
          TError,
          Awaited<ReturnType<typeof countExceptionsByAutomation>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useCountExceptionsByAutomation<
  TData = Awaited<ReturnType<typeof countExceptionsByAutomation>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  params?: CountExceptionsByAutomationParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof countExceptionsByAutomation>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Counts exceptions by automation.
Returns a list of automations with their exception counts.
Useful for identifying which automations have the most exceptions.
 */

export function useCountExceptionsByAutomation<
  TData = Awaited<ReturnType<typeof countExceptionsByAutomation>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  params?: CountExceptionsByAutomationParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof countExceptionsByAutomation>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getCountExceptionsByAutomationQueryOptions(
    organization,
    workspace,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Counts exceptions by group.
Returns a map of group identifiers to exception counts.
Useful for displaying group statistics in dashboards.
 */
export const countExceptionsByGroup = (
  organization: string,
  workspace: string,
  params?: CountExceptionsByGroupParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1CountExceptionsByGroupResponse>> => {
  return axios.default.get(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/exceptions:countByGroup`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getCountExceptionsByGroupQueryKey = (
  organization?: string,
  workspace?: string,
  params?: CountExceptionsByGroupParams,
) => {
  return [
    `/api/v1/organizations/${organization}/workspaces/${workspace}/exceptions:countByGroup`,
    ...(params ? [params] : []),
  ] as const;
};

export const getCountExceptionsByGroupQueryOptions = <
  TData = Awaited<ReturnType<typeof countExceptionsByGroup>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  params?: CountExceptionsByGroupParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof countExceptionsByGroup>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getCountExceptionsByGroupQueryKey(organization, workspace, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof countExceptionsByGroup>>
  > = ({ signal }) =>
    countExceptionsByGroup(organization, workspace, params, {
      signal,
      ...axiosOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled: !!(organization && workspace),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof countExceptionsByGroup>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type CountExceptionsByGroupQueryResult = NonNullable<
  Awaited<ReturnType<typeof countExceptionsByGroup>>
>;
export type CountExceptionsByGroupQueryError = AxiosError<RpcStatus>;

export function useCountExceptionsByGroup<
  TData = Awaited<ReturnType<typeof countExceptionsByGroup>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  params: undefined | CountExceptionsByGroupParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof countExceptionsByGroup>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof countExceptionsByGroup>>,
          TError,
          Awaited<ReturnType<typeof countExceptionsByGroup>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useCountExceptionsByGroup<
  TData = Awaited<ReturnType<typeof countExceptionsByGroup>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  params?: CountExceptionsByGroupParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof countExceptionsByGroup>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof countExceptionsByGroup>>,
          TError,
          Awaited<ReturnType<typeof countExceptionsByGroup>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useCountExceptionsByGroup<
  TData = Awaited<ReturnType<typeof countExceptionsByGroup>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  params?: CountExceptionsByGroupParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof countExceptionsByGroup>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Counts exceptions by group.
Returns a map of group identifiers to exception counts.
Useful for displaying group statistics in dashboards.
 */

export function useCountExceptionsByGroup<
  TData = Awaited<ReturnType<typeof countExceptionsByGroup>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  params?: CountExceptionsByGroupParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof countExceptionsByGroup>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getCountExceptionsByGroupQueryOptions(
    organization,
    workspace,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Queries exception insights including MTTR and trends over time periods.
Useful for dashboards and analytics to understand exception patterns and resolution times.
This is a custom method for analytics/reporting, not a standard Get operation.
 */
export const queryExceptionInsights = (
  organization: string,
  workspace: string,
  exceptionManagerServiceQueryExceptionInsightsBody: ExceptionManagerServiceQueryExceptionInsightsBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1QueryExceptionInsightsResponse>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/exceptions:queryInsights`,
    exceptionManagerServiceQueryExceptionInsightsBody,
    options,
  );
};

export const getQueryExceptionInsightsMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof queryExceptionInsights>>,
    TError,
    {
      organization: string;
      workspace: string;
      data: ExceptionManagerServiceQueryExceptionInsightsBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof queryExceptionInsights>>,
  TError,
  {
    organization: string;
    workspace: string;
    data: ExceptionManagerServiceQueryExceptionInsightsBody;
  },
  TContext
> => {
  const mutationKey = ['queryExceptionInsights'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof queryExceptionInsights>>,
    {
      organization: string;
      workspace: string;
      data: ExceptionManagerServiceQueryExceptionInsightsBody;
    }
  > = props => {
    const { organization, workspace, data } = props ?? {};

    return queryExceptionInsights(organization, workspace, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type QueryExceptionInsightsMutationResult = NonNullable<
  Awaited<ReturnType<typeof queryExceptionInsights>>
>;
export type QueryExceptionInsightsMutationBody =
  ExceptionManagerServiceQueryExceptionInsightsBody;
export type QueryExceptionInsightsMutationError = AxiosError<RpcStatus>;

/**
 * @summary Queries exception insights including MTTR and trends over time periods.
Useful for dashboards and analytics to understand exception patterns and resolution times.
This is a custom method for analytics/reporting, not a standard Get operation.
 */
export const useQueryExceptionInsights = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof queryExceptionInsights>>,
      TError,
      {
        organization: string;
        workspace: string;
        data: ExceptionManagerServiceQueryExceptionInsightsBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof queryExceptionInsights>>,
  TError,
  {
    organization: string;
    workspace: string;
    data: ExceptionManagerServiceQueryExceptionInsightsBody;
  },
  TContext
> => {
  const mutationOptions = getQueryExceptionInsightsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Retries multiple exceptions in a single request.
Only PENDING exceptions are retried; RESOLVED and ARCHIVED exceptions are skipped.
 */
export const retryExceptions = (
  organization: string,
  workspace: string,
  exceptionManagerServiceRetryExceptionsBody: ExceptionManagerServiceRetryExceptionsBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1RetryExceptionsResponse>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/exceptions:retry`,
    exceptionManagerServiceRetryExceptionsBody,
    options,
  );
};

export const getRetryExceptionsMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof retryExceptions>>,
    TError,
    {
      organization: string;
      workspace: string;
      data: ExceptionManagerServiceRetryExceptionsBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof retryExceptions>>,
  TError,
  {
    organization: string;
    workspace: string;
    data: ExceptionManagerServiceRetryExceptionsBody;
  },
  TContext
> => {
  const mutationKey = ['retryExceptions'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof retryExceptions>>,
    {
      organization: string;
      workspace: string;
      data: ExceptionManagerServiceRetryExceptionsBody;
    }
  > = props => {
    const { organization, workspace, data } = props ?? {};

    return retryExceptions(organization, workspace, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RetryExceptionsMutationResult = NonNullable<
  Awaited<ReturnType<typeof retryExceptions>>
>;
export type RetryExceptionsMutationBody =
  ExceptionManagerServiceRetryExceptionsBody;
export type RetryExceptionsMutationError = AxiosError<RpcStatus>;

/**
 * @summary Retries multiple exceptions in a single request.
Only PENDING exceptions are retried; RESOLVED and ARCHIVED exceptions are skipped.
 */
export const useRetryExceptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof retryExceptions>>,
      TError,
      {
        organization: string;
        workspace: string;
        data: ExceptionManagerServiceRetryExceptionsBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof retryExceptions>>,
  TError,
  {
    organization: string;
    workspace: string;
    data: ExceptionManagerServiceRetryExceptionsBody;
  },
  TContext
> => {
  const mutationOptions = getRetryExceptionsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Skips multiple exceptions in a single request.
Only PENDING exceptions are skipped; RESOLVED and ARCHIVED exceptions are ignored.
 */
export const skipExceptions = (
  organization: string,
  workspace: string,
  exceptionManagerServiceSkipExceptionsBody: ExceptionManagerServiceSkipExceptionsBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1SkipExceptionsResponse>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/exceptions:skip`,
    exceptionManagerServiceSkipExceptionsBody,
    options,
  );
};

export const getSkipExceptionsMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof skipExceptions>>,
    TError,
    {
      organization: string;
      workspace: string;
      data: ExceptionManagerServiceSkipExceptionsBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof skipExceptions>>,
  TError,
  {
    organization: string;
    workspace: string;
    data: ExceptionManagerServiceSkipExceptionsBody;
  },
  TContext
> => {
  const mutationKey = ['skipExceptions'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof skipExceptions>>,
    {
      organization: string;
      workspace: string;
      data: ExceptionManagerServiceSkipExceptionsBody;
    }
  > = props => {
    const { organization, workspace, data } = props ?? {};

    return skipExceptions(organization, workspace, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SkipExceptionsMutationResult = NonNullable<
  Awaited<ReturnType<typeof skipExceptions>>
>;
export type SkipExceptionsMutationBody =
  ExceptionManagerServiceSkipExceptionsBody;
export type SkipExceptionsMutationError = AxiosError<RpcStatus>;

/**
 * @summary Skips multiple exceptions in a single request.
Only PENDING exceptions are skipped; RESOLVED and ARCHIVED exceptions are ignored.
 */
export const useSkipExceptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof skipExceptions>>,
      TError,
      {
        organization: string;
        workspace: string;
        data: ExceptionManagerServiceSkipExceptionsBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof skipExceptions>>,
  TError,
  {
    organization: string;
    workspace: string;
    data: ExceptionManagerServiceSkipExceptionsBody;
  },
  TContext
> => {
  const mutationOptions = getSkipExceptionsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Unarchives ARCHIVED exceptions back to PENDING state.
Use this to undo accidental archive operations.
Non-ARCHIVED exceptions are ignored.
 */
export const unarchiveExceptions = (
  organization: string,
  workspace: string,
  exceptionManagerServiceUnarchiveExceptionsBody: ExceptionManagerServiceUnarchiveExceptionsBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1UnarchiveExceptionsResponse>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/exceptions:unarchive`,
    exceptionManagerServiceUnarchiveExceptionsBody,
    options,
  );
};

export const getUnarchiveExceptionsMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof unarchiveExceptions>>,
    TError,
    {
      organization: string;
      workspace: string;
      data: ExceptionManagerServiceUnarchiveExceptionsBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof unarchiveExceptions>>,
  TError,
  {
    organization: string;
    workspace: string;
    data: ExceptionManagerServiceUnarchiveExceptionsBody;
  },
  TContext
> => {
  const mutationKey = ['unarchiveExceptions'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof unarchiveExceptions>>,
    {
      organization: string;
      workspace: string;
      data: ExceptionManagerServiceUnarchiveExceptionsBody;
    }
  > = props => {
    const { organization, workspace, data } = props ?? {};

    return unarchiveExceptions(organization, workspace, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UnarchiveExceptionsMutationResult = NonNullable<
  Awaited<ReturnType<typeof unarchiveExceptions>>
>;
export type UnarchiveExceptionsMutationBody =
  ExceptionManagerServiceUnarchiveExceptionsBody;
export type UnarchiveExceptionsMutationError = AxiosError<RpcStatus>;

/**
 * @summary Unarchives ARCHIVED exceptions back to PENDING state.
Use this to undo accidental archive operations.
Non-ARCHIVED exceptions are ignored.
 */
export const useUnarchiveExceptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof unarchiveExceptions>>,
      TError,
      {
        organization: string;
        workspace: string;
        data: ExceptionManagerServiceUnarchiveExceptionsBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof unarchiveExceptions>>,
  TError,
  {
    organization: string;
    workspace: string;
    data: ExceptionManagerServiceUnarchiveExceptionsBody;
  },
  TContext
> => {
  const mutationOptions = getUnarchiveExceptionsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Classifies a specific exception with a group.
Setting group also triggers auto-assignee routing server-side, identical to the
legacy create-time behavior.
This is an internal gRPC-only method (called by the Rain Astral agent); it is
intentionally not exposed over HTTP/REST.
 */
export const classifyException = (
  v1ClassifyExceptionRequest: V1ClassifyExceptionRequest,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1Exception>> => {
  return axios.default.post(
    `/astral.v1.ExceptionManagerService/ClassifyException`,
    v1ClassifyExceptionRequest,
    options,
  );
};

export const getClassifyExceptionMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof classifyException>>,
    TError,
    { data: V1ClassifyExceptionRequest },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof classifyException>>,
  TError,
  { data: V1ClassifyExceptionRequest },
  TContext
> => {
  const mutationKey = ['classifyException'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof classifyException>>,
    { data: V1ClassifyExceptionRequest }
  > = props => {
    const { data } = props ?? {};

    return classifyException(data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ClassifyExceptionMutationResult = NonNullable<
  Awaited<ReturnType<typeof classifyException>>
>;
export type ClassifyExceptionMutationBody = V1ClassifyExceptionRequest;
export type ClassifyExceptionMutationError = AxiosError<RpcStatus>;

/**
 * @summary Classifies a specific exception with a group.
Setting group also triggers auto-assignee routing server-side, identical to the
legacy create-time behavior.
This is an internal gRPC-only method (called by the Rain Astral agent); it is
intentionally not exposed over HTTP/REST.
 */
export const useClassifyException = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof classifyException>>,
      TError,
      { data: V1ClassifyExceptionRequest },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof classifyException>>,
  TError,
  { data: V1ClassifyExceptionRequest },
  TContext
> => {
  const mutationOptions = getClassifyExceptionMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Lists all stored exception resolutions for a run. Internal gRPC-only method,
not exposed over HTTP/REST. Pagination is intentionally omitted for now.
 */
export const listExceptionResolutions = (
  v1ListExceptionResolutionsRequest: V1ListExceptionResolutionsRequest,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1ListExceptionResolutionsResponse>> => {
  return axios.default.post(
    `/astral.v1.ExceptionManagerService/ListExceptionResolutions`,
    v1ListExceptionResolutionsRequest,
    options,
  );
};

export const getListExceptionResolutionsMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof listExceptionResolutions>>,
    TError,
    { data: V1ListExceptionResolutionsRequest },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof listExceptionResolutions>>,
  TError,
  { data: V1ListExceptionResolutionsRequest },
  TContext
> => {
  const mutationKey = ['listExceptionResolutions'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof listExceptionResolutions>>,
    { data: V1ListExceptionResolutionsRequest }
  > = props => {
    const { data } = props ?? {};

    return listExceptionResolutions(data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ListExceptionResolutionsMutationResult = NonNullable<
  Awaited<ReturnType<typeof listExceptionResolutions>>
>;
export type ListExceptionResolutionsMutationBody =
  V1ListExceptionResolutionsRequest;
export type ListExceptionResolutionsMutationError = AxiosError<RpcStatus>;

/**
 * @summary Lists all stored exception resolutions for a run. Internal gRPC-only method,
not exposed over HTTP/REST. Pagination is intentionally omitted for now.
 */
export const useListExceptionResolutions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof listExceptionResolutions>>,
      TError,
      { data: V1ListExceptionResolutionsRequest },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof listExceptionResolutions>>,
  TError,
  { data: V1ListExceptionResolutionsRequest },
  TContext
> => {
  const mutationOptions = getListExceptionResolutionsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Marks a specific exception as RESOLVED.
Internal gRPC-only method called by the Rain Astral agent once it has
finished resolving an exception; intentionally not exposed over HTTP/REST.
State-only: it updates the stored state (and resolver attribution) but does
not resume the run or notify users.
 */
export const markExceptionResolved = (
  v1MarkExceptionResolvedRequest: V1MarkExceptionResolvedRequest,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1Exception>> => {
  return axios.default.post(
    `/astral.v1.ExceptionManagerService/MarkExceptionResolved`,
    v1MarkExceptionResolvedRequest,
    options,
  );
};

export const getMarkExceptionResolvedMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof markExceptionResolved>>,
    TError,
    { data: V1MarkExceptionResolvedRequest },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof markExceptionResolved>>,
  TError,
  { data: V1MarkExceptionResolvedRequest },
  TContext
> => {
  const mutationKey = ['markExceptionResolved'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof markExceptionResolved>>,
    { data: V1MarkExceptionResolvedRequest }
  > = props => {
    const { data } = props ?? {};

    return markExceptionResolved(data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type MarkExceptionResolvedMutationResult = NonNullable<
  Awaited<ReturnType<typeof markExceptionResolved>>
>;
export type MarkExceptionResolvedMutationBody = V1MarkExceptionResolvedRequest;
export type MarkExceptionResolvedMutationError = AxiosError<RpcStatus>;

/**
 * @summary Marks a specific exception as RESOLVED.
Internal gRPC-only method called by the Rain Astral agent once it has
finished resolving an exception; intentionally not exposed over HTTP/REST.
State-only: it updates the stored state (and resolver attribution) but does
not resume the run or notify users.
 */
export const useMarkExceptionResolved = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof markExceptionResolved>>,
      TError,
      { data: V1MarkExceptionResolvedRequest },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof markExceptionResolved>>,
  TError,
  { data: V1MarkExceptionResolvedRequest },
  TContext
> => {
  const mutationOptions = getMarkExceptionResolvedMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Patches a single exception's failing step and resumes its run.
Server behavior: validates the exception is still PENDING, validates the patch via
jarvis ValidatePatch, resumes the run via jeeves ResumeRun (patch action), then
marks the exception RESOLVED (system-handled and is_source_fix_required recorded).
Internal gRPC-only method; intentionally not exposed over HTTP/REST.
 */
export const patchStep = (
  v1PatchStepRequest: V1PatchStepRequest,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1PatchStepResponse>> => {
  return axios.default.post(
    `/astral.v1.ExceptionManagerService/PatchStep`,
    v1PatchStepRequest,
    options,
  );
};

export const getPatchStepMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchStep>>,
    TError,
    { data: V1PatchStepRequest },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchStep>>,
  TError,
  { data: V1PatchStepRequest },
  TContext
> => {
  const mutationKey = ['patchStep'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchStep>>,
    { data: V1PatchStepRequest }
  > = props => {
    const { data } = props ?? {};

    return patchStep(data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PatchStepMutationResult = NonNullable<
  Awaited<ReturnType<typeof patchStep>>
>;
export type PatchStepMutationBody = V1PatchStepRequest;
export type PatchStepMutationError = AxiosError<RpcStatus>;

/**
 * @summary Patches a single exception's failing step and resumes its run.
Server behavior: validates the exception is still PENDING, validates the patch via
jarvis ValidatePatch, resumes the run via jeeves ResumeRun (patch action), then
marks the exception RESOLVED (system-handled and is_source_fix_required recorded).
Internal gRPC-only method; intentionally not exposed over HTTP/REST.
 */
export const usePatchStep = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof patchStep>>,
      TError,
      { data: V1PatchStepRequest },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof patchStep>>,
  TError,
  { data: V1PatchStepRequest },
  TContext
> => {
  const mutationOptions = getPatchStepMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Reads a page of recorded runtime evidence, decoding offloaded containers.
File and table values retain their references for the Bishop artifact reader.
 */
export const readExceptionValue = (
  v1ReadExceptionValueRequest: V1ReadExceptionValueRequest,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1ReadExceptionValueResponse>> => {
  return axios.default.post(
    `/astral.v1.ExceptionManagerService/ReadExceptionValue`,
    v1ReadExceptionValueRequest,
    options,
  );
};

export const getReadExceptionValueMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof readExceptionValue>>,
    TError,
    { data: V1ReadExceptionValueRequest },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof readExceptionValue>>,
  TError,
  { data: V1ReadExceptionValueRequest },
  TContext
> => {
  const mutationKey = ['readExceptionValue'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof readExceptionValue>>,
    { data: V1ReadExceptionValueRequest }
  > = props => {
    const { data } = props ?? {};

    return readExceptionValue(data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ReadExceptionValueMutationResult = NonNullable<
  Awaited<ReturnType<typeof readExceptionValue>>
>;
export type ReadExceptionValueMutationBody = V1ReadExceptionValueRequest;
export type ReadExceptionValueMutationError = AxiosError<RpcStatus>;

/**
 * @summary Reads a page of recorded runtime evidence, decoding offloaded containers.
File and table values retain their references for the Bishop artifact reader.
 */
export const useReadExceptionValue = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof readExceptionValue>>,
      TError,
      { data: V1ReadExceptionValueRequest },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof readExceptionValue>>,
  TError,
  { data: V1ReadExceptionValueRequest },
  TContext
> => {
  const mutationOptions = getReadExceptionValueMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Retries a single exception's failing step without code changes.
Server behavior: validates PENDING, resumes via jeeves ResumeRun, marks RESOLVED
(system-handled = true).
Internal gRPC-only method; intentionally not exposed over HTTP/REST.
 */
export const retryStep = (
  v1RetryStepRequest: V1RetryStepRequest,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1RetryStepResponse>> => {
  return axios.default.post(
    `/astral.v1.ExceptionManagerService/RetryStep`,
    v1RetryStepRequest,
    options,
  );
};

export const getRetryStepMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof retryStep>>,
    TError,
    { data: V1RetryStepRequest },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof retryStep>>,
  TError,
  { data: V1RetryStepRequest },
  TContext
> => {
  const mutationKey = ['retryStep'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof retryStep>>,
    { data: V1RetryStepRequest }
  > = props => {
    const { data } = props ?? {};

    return retryStep(data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RetryStepMutationResult = NonNullable<
  Awaited<ReturnType<typeof retryStep>>
>;
export type RetryStepMutationBody = V1RetryStepRequest;
export type RetryStepMutationError = AxiosError<RpcStatus>;

/**
 * @summary Retries a single exception's failing step without code changes.
Server behavior: validates PENDING, resumes via jeeves ResumeRun, marks RESOLVED
(system-handled = true).
Internal gRPC-only method; intentionally not exposed over HTTP/REST.
 */
export const useRetryStep = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof retryStep>>,
      TError,
      { data: V1RetryStepRequest },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof retryStep>>,
  TError,
  { data: V1RetryStepRequest },
  TContext
> => {
  const mutationOptions = getRetryStepMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Skips a single exception's failing step.
Server behavior: validates PENDING, resumes via jeeves ResumeRun (skip action),
marks RESOLVED (system-handled = true).
Internal gRPC-only method; intentionally not exposed over HTTP/REST.
 */
export const skipStep = (
  v1SkipStepRequest: V1SkipStepRequest,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1SkipStepResponse>> => {
  return axios.default.post(
    `/astral.v1.ExceptionManagerService/SkipStep`,
    v1SkipStepRequest,
    options,
  );
};

export const getSkipStepMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof skipStep>>,
    TError,
    { data: V1SkipStepRequest },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof skipStep>>,
  TError,
  { data: V1SkipStepRequest },
  TContext
> => {
  const mutationKey = ['skipStep'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof skipStep>>,
    { data: V1SkipStepRequest }
  > = props => {
    const { data } = props ?? {};

    return skipStep(data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SkipStepMutationResult = NonNullable<
  Awaited<ReturnType<typeof skipStep>>
>;
export type SkipStepMutationBody = V1SkipStepRequest;
export type SkipStepMutationError = AxiosError<RpcStatus>;

/**
 * @summary Skips a single exception's failing step.
Server behavior: validates PENDING, resumes via jeeves ResumeRun (skip action),
marks RESOLVED (system-handled = true).
Internal gRPC-only method; intentionally not exposed over HTTP/REST.
 */
export const useSkipStep = <TError = AxiosError<RpcStatus>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof skipStep>>,
      TError,
      { data: V1SkipStepRequest },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof skipStep>>,
  TError,
  { data: V1SkipStepRequest },
  TContext
> => {
  const mutationOptions = getSkipStepMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Queues Astral Lite's report for Workbench, replacing the previous payload
for this exception. Repeating the same request does not create duplicates.
The service resolves fact types through Jarvis using the exception's saved
execution ID; caller-supplied types are ignored. Unresolved types remain
absent; a type-lookup failure does not block report acceptance. Fact values
are copied from the saved runtime snapshot. This method does not resolve
or resume the exception.
 */
export const storeExceptionReport = (
  v1StoreExceptionReportRequest: V1StoreExceptionReportRequest,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1StoreExceptionReportResponse>> => {
  return axios.default.post(
    `/astral.v1.ExceptionManagerService/StoreExceptionReport`,
    v1StoreExceptionReportRequest,
    options,
  );
};

export const getStoreExceptionReportMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof storeExceptionReport>>,
    TError,
    { data: V1StoreExceptionReportRequest },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof storeExceptionReport>>,
  TError,
  { data: V1StoreExceptionReportRequest },
  TContext
> => {
  const mutationKey = ['storeExceptionReport'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof storeExceptionReport>>,
    { data: V1StoreExceptionReportRequest }
  > = props => {
    const { data } = props ?? {};

    return storeExceptionReport(data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type StoreExceptionReportMutationResult = NonNullable<
  Awaited<ReturnType<typeof storeExceptionReport>>
>;
export type StoreExceptionReportMutationBody = V1StoreExceptionReportRequest;
export type StoreExceptionReportMutationError = AxiosError<RpcStatus>;

/**
 * @summary Queues Astral Lite's report for Workbench, replacing the previous payload
for this exception. Repeating the same request does not create duplicates.
The service resolves fact types through Jarvis using the exception's saved
execution ID; caller-supplied types are ignored. Unresolved types remain
absent; a type-lookup failure does not block report acceptance. Fact values
are copied from the saved runtime snapshot. This method does not resolve
or resume the exception.
 */
export const useStoreExceptionReport = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof storeExceptionReport>>,
      TError,
      { data: V1StoreExceptionReportRequest },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof storeExceptionReport>>,
  TError,
  { data: V1StoreExceptionReportRequest },
  TContext
> => {
  const mutationOptions = getStoreExceptionReportMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Stores the resolution content for a specific exception (operational record).
Internal gRPC-only method called by the Rain Astral agent; intentionally not
exposed over HTTP/REST.
 */
export const storeExceptionResolution = (
  v1StoreExceptionResolutionRequest: V1StoreExceptionResolutionRequest,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1StoreExceptionResolutionResponse>> => {
  return axios.default.post(
    `/astral.v1.ExceptionManagerService/StoreExceptionResolution`,
    v1StoreExceptionResolutionRequest,
    options,
  );
};

export const getStoreExceptionResolutionMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof storeExceptionResolution>>,
    TError,
    { data: V1StoreExceptionResolutionRequest },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof storeExceptionResolution>>,
  TError,
  { data: V1StoreExceptionResolutionRequest },
  TContext
> => {
  const mutationKey = ['storeExceptionResolution'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof storeExceptionResolution>>,
    { data: V1StoreExceptionResolutionRequest }
  > = props => {
    const { data } = props ?? {};

    return storeExceptionResolution(data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type StoreExceptionResolutionMutationResult = NonNullable<
  Awaited<ReturnType<typeof storeExceptionResolution>>
>;
export type StoreExceptionResolutionMutationBody =
  V1StoreExceptionResolutionRequest;
export type StoreExceptionResolutionMutationError = AxiosError<RpcStatus>;

/**
 * @summary Stores the resolution content for a specific exception (operational record).
Internal gRPC-only method called by the Rain Astral agent; intentionally not
exposed over HTTP/REST.
 */
export const useStoreExceptionResolution = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof storeExceptionResolution>>,
      TError,
      { data: V1StoreExceptionResolutionRequest },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof storeExceptionResolution>>,
  TError,
  { data: V1StoreExceptionResolutionRequest },
  TContext
> => {
  const mutationOptions = getStoreExceptionResolutionMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Searches resolution-kind guide entries for an automation by full-text relevance.
Custom method (AIP-136): ranks the latest version of each entry by a weighted
full-text score and returns advisory matches. The caller (an LLM agent) supplies
the query, having reformulated the exception into resolution-vocabulary terms;
the server normalizes it and ranks.
before applying. gRPC-only (no HTTP transcoding).
 */
export const searchResolutions = (
  v1SearchResolutionsRequest: V1SearchResolutionsRequest,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1SearchResolutionsResponse>> => {
  return axios.default.post(
    `/astral.v1.TroubleshootingGuideService/SearchResolutions`,
    v1SearchResolutionsRequest,
    options,
  );
};

export const getSearchResolutionsMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof searchResolutions>>,
    TError,
    { data: V1SearchResolutionsRequest },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof searchResolutions>>,
  TError,
  { data: V1SearchResolutionsRequest },
  TContext
> => {
  const mutationKey = ['searchResolutions'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof searchResolutions>>,
    { data: V1SearchResolutionsRequest }
  > = props => {
    const { data } = props ?? {};

    return searchResolutions(data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SearchResolutionsMutationResult = NonNullable<
  Awaited<ReturnType<typeof searchResolutions>>
>;
export type SearchResolutionsMutationBody = V1SearchResolutionsRequest;
export type SearchResolutionsMutationError = AxiosError<RpcStatus>;

/**
 * @summary Searches resolution-kind guide entries for an automation by full-text relevance.
Custom method (AIP-136): ranks the latest version of each entry by a weighted
full-text score and returns advisory matches. The caller (an LLM agent) supplies
the query, having reformulated the exception into resolution-vocabulary terms;
the server normalizes it and ranks.
before applying. gRPC-only (no HTTP transcoding).
 */
export const useSearchResolutions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof searchResolutions>>,
      TError,
      { data: V1SearchResolutionsRequest },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof searchResolutions>>,
  TError,
  { data: V1SearchResolutionsRequest },
  TContext
> => {
  const mutationOptions = getSearchResolutionsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
